export enum ROUTE_PARAMS {
  AppointmentId = 'appointmentId',
  OrderReF = 'orderRef',
  PaymentIntentClientSecret = 'payment_intent_client_secret',
  StripeRedirectStatus = 'redirect_status',
  Lang = 'lang'
}
